import { Component, OnInit } from '@angular/core';

import { Router,  NavigationExtras, ActivatedRoute } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataService } from '../service/data.service';
import { CallBackEndService } from '../call-back-end.service';
@Component({
  selector: 'app-show-success',
  templateUrl: './show-success.component.html',
  styleUrls: ['./show-success.component.css'],
  providers: [DataService]
})
export class ShowSuccessComponent implements OnInit {

returnUrl: string;
message:string;
  bankName: any;
  constructor( private route: ActivatedRoute,
      private fb: FormBuilder,
      private authenticationservice: DataService,
      public router: Router,webService : CallBackEndService) {
        this.bankName = webService.getBankName();

   }
  backHome()
  {
    this.router.navigate([this.returnUrl]); 
  }
  ngOnInit() {

        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/index';
          this.message=sessionStorage.getItem('showSuccessMsg');
  }

}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/show-success/show-success.component.ts